module.exports = __webpack_public_path__ + "img/minip_app_image_handwritting@2x.dae20887.png";